import React from "react";
import BaseCard from "./BaseCard";
import InputTypesEnum from "../../../../Enums/InputTypesEnum";
import CardHeader from "./CardHeader";
import NoteCard from "./NoteCard";
import DataTable from "../../../../Elements/DataTable/DataTableFigma";
import FieldTypesEnum from '../../../../Enums/FieldTypesEnum';
import moneyHelper from '../../../../Helpers/moneyHelper';

class EmployeeCostCard extends BaseCard {
  FieldsToShowInDataTableHeader() {
    return [
      { label: ' ', tableminWidth: '250px' },
      { label: 'Override', tableminWidth: '125px' },
      { label: 'Override value', tableminWidth: '125px' },
      { label: 'mandays per cycle', tableminWidth: '125px' },
      { label: 'salary per cycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: 'Annually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '% of revenues', tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }

  FieldsToShowInDataTableByCostType = (label, type) => {
    return [
      { label, data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '250px' },
      {
        label: 'Is Overrid',
        // TeamLeadDailyCostOverride, ProjMgrDailyCostOverride, OperationsMgrDailyCostOverride,
        // AssistantProjMgrDailyCostOverride, PanelMgrRecruiterDailyCostOverride, EditDataCheckDailyCostOverride
        data: `${type}DailyCostOverride`,
        type: InputTypesEnum.SingleCheckBox,
        fieldClass: ' ',
        tableminWidth: '125px',
      },
      this.GetOverrideField(type),
      {
        label: 'mandays per cycle',
        // TeamLeadDaysPerCycle, ProjMgrDaysPerCycle, OperationsMgrDaysPerCycle,
        // AssistantProjMgrDaysPerCycle, PanelMgrRecruiterDaysPerCycle, EditDataCheckDaysPerCycle
        data: `${type}DaysPerCycle`,
        type: InputTypesEnum.Text2,
        tableminWidth: '125px',
        fieldType: 'Decimal',
      },
      {
        //Cost per cycle

        // TeamLeadDailyCostOverrideCur, ProjMgrDailyCostOverrideCur, OperationsMgrDailyCostOverrideCur,
        // AssistantProjMgrDailyCostOverrideCur, PanelMgrRecruiterDailyCostOverrideCur, EditDataCheckDailyCostOverrideCur
        data: (item) =>
          moneyHelper.toMoneyFormat(
            item[`${type}DailyCostOverrideCur`] * item[`${type}DaysPerCycle`],
            item.CurrencyCode
          ),
        tableminWidth: '125px',
        type: InputTypesEnum.TextReadOnly,
        headerPosition: 'header-text-right',
      },
      {
        // Annually Cost
        data: (item) => {
          return moneyHelper.toMoneyFormat(
            item[`${type}DailyCostOverrideCur`] * item[`${type}DaysPerCycle`] * item.NumCyclesPerYr,
            item.CurrencyCode
          );
        },
        tableminWidth: '125px',
        type: InputTypesEnum.TextReadOnly,
        headerPosition: 'header-text-right',
      },
      {
        // % of revenues
        // TeamLeadSalaryPct, ProjMgrSalaryPct, OperationsMgrSalaryPct,
        // AssistantProjMgrSalaryPct, PanelMgrRecruiterSalaryPct, EditDataCheckSalaryPct
        data: `${type}SalaryPct`,
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  };

  GetOverrideField(type) {
    // TeamLeadDailyCostOverrideCur, ProjMgrDailyCostOverrideCur, OperationsMgrDailyCostOverrideCur,
    // AssistantProjMgrDailyCostOverrideCur, PanelMgrRecruiterDailyCostOverrideCur, EditDataCheckDailyCostOverrideCur
    return this.props.Tier.PricingDetails[`${type}DailyCostOverride`]
      ? {
          label: 'Override value',
          data: `${type}DailyCostOverrideCur`,
          type: InputTypesEnum.NumberWithTwoDecimalPlaces2,
          tableminWidth: '125px',
        }
      : {
          label: 'Override value',
          data: (item) => moneyHelper.toMoneyFormat(item[`${type}DailyCostOverrideCur`], item.CurrencyCode),
          type: InputTypesEnum.TextReadOnly,
          tableminWidth: '125px',
        };
  }

  FieldsToShowInDataTableMandaysPerClientCycle() {
    return [
      {
        label: 'Total # of mandays per client cycle',
        data: '',
        type: FieldTypesEnum.JustLabel,
        tableminWidth: '250px',
      },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { data: 'DaysPerCycleTotal', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
    ];
  }

  FieldsToShowInDataTableSubEmployeeCost() {
    return [
      { label: 'SUB EMPLOYEE COST', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '250px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      {
        data: 'EmployeeCostPerCycle',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        data: 'EmployeeCostSubTotal',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        data: 'EmployeeCostSubPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }

  FieldsToShowInDataTablePayrollTax() {
    return [
      { label: 'Payroll tax (if applicable)', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '250px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { data: 'PayrollTaxPct', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { data: 'PayrollTaxPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: 'PayrollTaxAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        data: 'PayrollTaxTotalPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }

  FieldsToShowInDataTableEmployeeBenefitsCost() {
    return [
      { label: 'Employee benefits cost', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '250px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { data: 'EmpBenefitsDailyCost', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { data: 'EmpBenefitsPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: 'EmpBenefitsAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        data: 'EmpBenefitsPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }

  FieldsToShowInDataTableCommission() {
    return [
      { label: 'Commission', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '250px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { label: '', data: '', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { data: 'CommissionPct', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px' },
      { data: 'CommissionPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: 'CommissionAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        data: 'CommissionTotalPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }

  FieldsToShowInFooterDataTable() {
    return [
      { label: 'TOTAL EMPLOYEE COST', tableminWidth: '750px', headerPosition: 'header-text-right' },
      { label: '', data: 'EmployeeCostTotal', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '', data: 'EmployeeCostPct', tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }

  renderCardHeader() {
    return (
      <CardHeader
        sectionNumber={'7'}
        HeaderText={'EMPLOYEE COST'}
        changeBodyStatus={this.changeBodyStatus}
        bodyactive={this.state.bodyactive}
        subtotal={moneyHelper.toMoneyFormat(this.props.Tier.EmployeeCostTotal, this.props.Tier.PricingDetails.CurrencyCode)}
        subtotalRev={this.props.Tier.EmployeeCostPct + ' of revenue'}
      />
    );
  }
  renderNotes() {
    return (
      <NoteCard
        noteActive={this.state.noteActive}
        renderInputField={this.renderInputField}
        name='EmployeeCostNotes'
        value={this.props.Tier.PricingDetails}
      />
    );
  }

  renderHeader() {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableHeader,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Header'
        thereIsNoSuchRowMessageCheck={false}
        smallDataTable={true}
      />
    );
  }

  renderDataTableMandaysPerClientCycle(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableMandaysPerClientCycle,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDataTableSubEmployeeCost(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableSubEmployeeCost,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDataTablePayrollTax(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTablePayrollTax,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDataTableEmployeeBenefitsCost(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableEmployeeBenefitsCost,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDataTableCommission(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableCommission,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderFooterDataTable(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInFooterDataTable,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        FieldsToShowInDataTable={this.FieldsToShowInFooterDataTable()}
        headeritemList={this.props.Tier}
        DataTableType='Header'
        thereIsNoSuchRowMessageCheck={false}
        smallDataTable={true}
      />
    );
  }

  renderDataTableByCostType(Tier, label, type) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: () => this.FieldsToShowInDataTableByCostType(label, type),
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier.PricingDetails}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  render() {
    const { Tier } = this.props;

    return (
      <div className='card'>
        {this.renderCardHeader()}
        {this.state.bodyactive ? (
          <div>
            {this.renderNotes()}
            {this.renderHeader()}
            {this.renderDataTableByCostType(Tier, 'Senior Project Mgr Cost', 'TeamLead')}
            {this.renderDataTableByCostType(Tier, 'Project Mgr Cost', 'ProjMgr')}
            {this.renderDataTableByCostType(Tier, 'Operations Mgr Cost', 'OperationsMgr')}
            {this.renderDataTableByCostType(Tier, 'Assistant Project Mgr Cost', 'AssistantProjMgr')}
            {this.renderDataTableByCostType(Tier, 'Recruiter Cost', 'PanelMgrRecruiter')}
            {this.renderDataTableByCostType(Tier, 'Datachecker Cost', 'EditDataCheck')}
            {this.renderDataTableMandaysPerClientCycle(Tier)}
            {this.renderDataTableSubEmployeeCost(Tier)}
            {this.renderDataTablePayrollTax(Tier)}
            {this.renderDataTableEmployeeBenefitsCost(Tier)}
            {this.renderDataTableCommission(Tier)}
          </div>
        ) : null}
        <footer>{this.renderFooterDataTable(Tier)}</footer>
      </div>
    );
  }
}

export default EmployeeCostCard;
